/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface RqthDeclarationEventTimelinePayload
 */
export interface RqthDeclarationEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof RqthDeclarationEventTimelinePayload
     */
    declarationId: string;
    /**
     * 
     * @type {string}
     * @memberof RqthDeclarationEventTimelinePayload
     */
    refusalReason?: string;
    /**
     * 
     * @type {number}
     * @memberof RqthDeclarationEventTimelinePayload
     */
    ticketId?: number;
    /**
     * 
     * @type {string}
     * @memberof RqthDeclarationEventTimelinePayload
     */
    ticketUrl?: string;
}

/**
 * Check if a given object implements the RqthDeclarationEventTimelinePayload interface.
 */
export function instanceOfRqthDeclarationEventTimelinePayload(value: object): value is RqthDeclarationEventTimelinePayload {
    if (!('declarationId' in value) || value['declarationId'] === undefined) return false;
    return true;
}

export function RqthDeclarationEventTimelinePayloadFromJSON(json: any): RqthDeclarationEventTimelinePayload {
    return RqthDeclarationEventTimelinePayloadFromJSONTyped(json, false);
}

export function RqthDeclarationEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): RqthDeclarationEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'declarationId': json['declarationId'],
        'refusalReason': json['refusalReason'] == null ? undefined : json['refusalReason'],
        'ticketId': json['ticketId'] == null ? undefined : json['ticketId'],
        'ticketUrl': json['ticketUrl'] == null ? undefined : json['ticketUrl'],
    };
}

export function RqthDeclarationEventTimelinePayloadToJSON(value?: RqthDeclarationEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'declarationId': value['declarationId'],
        'refusalReason': value['refusalReason'],
        'ticketId': value['ticketId'],
        'ticketUrl': value['ticketUrl'],
    };
}

